import { RefObject, useEffect, useState } from "react";

export const useIsTruncated = (ref: RefObject<HTMLElement>, dependencies: any[] = []) => {
	const [isTruncated, setIsTruncated] = useState(false);

	useEffect(() => {
		const element = ref.current;
		if (!element) return;

		const checkTruncation = () => {
			setIsTruncated(element.scrollHeight > element.clientHeight);
		};

		const observer = new ResizeObserver(checkTruncation);
		observer.observe(element);
		checkTruncation();

		return () => observer.disconnect();
	}, [ref, ...dependencies]);

	return isTruncated;
};
